import { post } from '../service';
import { UrlBuilder } from '../urlBuilder';

export const getAddressesList = async (payload) => {
  const builder = new UrlBuilder(`/get-addresses`);
  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const getAddressesCoordinates = async (payload) => {
  const builder = new UrlBuilder(`/get-property-details`);
  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const getOverlayByAddressCoordinates = async (payload) => {
  const builder = new UrlBuilder(`/get-overlay-points`);
  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const getOverlaysAplliedForAddress = async (payload) => {
  const builder = new UrlBuilder(`/get-applicable-overlays`);
  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const getIntersectingPrecincts = async (payload) => {
  const builder = new UrlBuilder(`/get-intersecting-precincts`);
  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const checkCacheStatus = async (payload) => {
  const builder = new UrlBuilder(`/council/get-geojson-status`);
  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};
